import Vue from 'vue';
import router from './router';
import App from './App';
import ElementUI from 'element-ui';
import "./assets/amp-theme/index.css";
import vParticles from '@agustinm/v-particles';
import Home from './components/Home';
import Info from './components/Info';
import Editor from './components/Editor';

Vue.use(ElementUI);
Vue.use(vParticles);

Vue.component('home-component', Home);
Vue.component('info-component', Info);
Vue.component('editor-component', Editor);

new Vue({
   el: '#app',
   router,
   template: '<App/>',
   components: {
      App,
   },
});



// WEBPACK FOOTER //
// ./src/main.js